import { useEffect } from "react";
import { useMatches } from "react-router-dom";
import { useStoreState } from "providers/StoreStateContext";

type NavHandle = {
  mainCategory?: string;
};

type NavMatch = {
  pathname: string;
  handle?: NavHandle;
};

export const useSyncNavMemoryWithRouter = () => {
  const matches = useMatches() as NavMatch[];
  const { setLastSubroute } = useStoreState();

  const leaf = matches[matches.length - 1];
  const category = leaf?.handle?.mainCategory;
  const pathname = leaf?.pathname;

  useEffect(() => {
    if (!category || !pathname) return;
    setLastSubroute(category, pathname);
  }, [category, pathname, setLastSubroute]);
};
